import { ReactNode } from "react";

interface ModuleHeaderProps {
  title: string;
  subtitle: string;
  accent?: "sky" | "lime" | "white";
  stats?: { label: string; value: string | number; tone?: "default" | "alert" | "good" }[];
  actions?: ReactNode;
}

const accentMap = {
  sky: "text-[#288CC8]",
  lime: "text-[#8CB43C]",
  white: "text-white",
};

const toneMap = {
  default: "text-white",
  alert: "text-[#E8A020]",
  good: "text-[#8CB43C]",
};

export const ModuleHeader = ({ title, subtitle, accent = "sky", stats, actions }: ModuleHeaderProps) => (
  <div className="bg-[#00283C] rounded-xl p-6 mb-6 border border-[#14508C]/40">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className={`text-3xl font-bold tracking-tight uppercase font-display ${accentMap[accent]}`}>{title}</h1>
        <p className="text-sm text-white/70 mt-1 italic">{subtitle}</p>
      </div>
      <div className="flex items-center gap-6">
        {stats && (
          <div className="flex gap-6">
            {stats.map((s) => (
              <div key={s.label} className="text-right">
                <div className="text-[10px] uppercase tracking-widest text-white/50">{s.label}</div>
                <div className={`text-lg font-bold ${toneMap[s.tone || "default"]}`}>{s.value}</div>
              </div>
            ))}
          </div>
        )}
        {actions}
      </div>
    </div>
  </div>
);

export default ModuleHeader;
